module.exports = __webpack_public_path__ + "img/w_mockup_400_box.4df54518.png";